



































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import NewReturnButton from '../atoms/NewReturnButton.vue'
import NewGradeButton from '../molecules/NewGradeButton.vue'

export default Vue.extend({
  components: {
    TitleName,
    NewReturnButton,
    NewGradeButton
  },
  computed: {
    // newContractsからキーを取得
    contractKeys(): string[] {
      const newContracts = this.$store.state.newContracts
      return newContracts ? Object.keys(newContracts) : []
    },
  },
  mounted() {
    // 背景をレンガ調から白に変更
    document.body.style.backgroundImage = 'none'
    document.body.style.backgroundColor = '#ffffff'
  },
  beforeDestroy() {
    // ページ離脱時に背景を元に戻す
    document.body.style.backgroundImage = ''
    document.body.style.backgroundColor = ''
  },
  async created() {
    const externalId = this.$cookies.get('external_id')
    // externalIdが空の場合にマイページに遷移
    if (!externalId) {
      window.location.href = `${process.env.VUE_APP_NEW_ROOT_PATH}/users/mypage`
      return
    }
    this.$store.commit('SET_EXTERNALID', externalId)
    this.$store.commit('SET_NEW_CONTRACTS', {})
    await this.$store.dispatch('getContracts')
  },
  methods: {
    // NewContentsPdf.vueへ遷移
    navigateToContents(gradeKey: string): void {
      this.$store.commit('SET_GRADE', { grade: { name: gradeKey } })
      this.$router.push(`/new/overseas_downloads/${gradeKey}`)
    },
    navigateToMyPage(): void {
      window.location.href = `${process.env.VUE_APP_NEW_ROOT_PATH}/users/mypage`
    }
  }
})
